<template>
  <weui-cell class="trainer-apply-cell">
    <div class="description">
      <div class="avatar">
        <img :src="trainerApply.wechat_headimgurl" title="头像">
        <i class="weui-icon-warn" />
      </div>
      <div class="info">
        <div class="head">
          <label class="title">新会员申请：{{ trainerApply.wechat_nickname }}</label>
        </div>
        <div class="info-line">性别：{{ formatGender(trainerApply.wechat_gender) }}</div>
        <div class="info-line">附言：{{ trainerApply.message }}</div>
      </div>
    </div>
    <div class="actions">
      <a role="button" class="btn btn-primary" @click="approve">通过</a>
      <a role="button" class="btn btn-default" @click="reject">拒绝</a>
    </div>
  </weui-cell>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from 'weui.js';

import { WeuiCell } from '@/components/weui';
import mixinFormatters from '@/mixins/formatters';
import { REJECT_TRAINER_APPLY, APPROVE_TRAINER_APPLY, FETCH_TRAINER_APPLIES } from '@/store/trainer_apply/types';

const { mapActions: mapTrainerApplyActions } = createNamespacedHelpers('trainer_apply');

export default {
    props: {
        trainerApply: {
            type: Object,
            required: true,
        },
    },
    methods: {
        ...mapTrainerApplyActions({
            rejectTrainerApply: REJECT_TRAINER_APPLY,
            approveTrainerApply: APPROVE_TRAINER_APPLY,
            fetchTrainerApplies: FETCH_TRAINER_APPLIES,
        }),
        approve() {
            weui.confirm(`确认要通过会员${this.trainerApply.wechat_nickname}的申请吗？`, () => {
                this.approveTrainerApply({ id: this.trainerApply.id })
                    .then(() => {
                        this.fetchTrainerApplies();
                    });
            });
        },
        reject() {
            weui.confirm(`确认要拒绝会员${this.trainerApply.wechat_nickname}的申请吗？`, () => {
                this.rejectTrainerApply({ id: this.trainerApply.id })
                    .then(() => {
                        this.fetchTrainerApplies();
                    });
            });
        },
    },
    mixins: [
        mixinFormatters,
    ],
    components: {
        WeuiCell,
    },
};
</script>

<style lang="scss" scoped>
.application {
    background-color: white;
}
.description {
    display: flex;
}

.avatar {
    width: 17.066666667vw;
    height: 17.066666667vw;
    flex: none;
    position: relative;

    > img {
        width: 100%;
        height: 100%;
        border-radius: 1.2vw;
        box-sizing: border-box;
        border: solid 1px #b4b4b4;
    }

    > .weui-icon-warn {
        position: absolute;;
        top: -1.6vw;
        right: -1.6vw;
        font-size: 4.266666667vw;
        &::before {
          margin: 0;
        }
    }
}

.info {
    margin-left: 3.2vw;
    flex: auto;
}

.title {
    color: black;
    font-size: 4.8vw;
    line-height: 9.333333333vw;
}
.info-line {
    font-size: 3.466666667vw;
    line-height: 1.4;
}

.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16vw;
    height: 8vw;
    border-radius: 0.8vw;
    box-sizing: border-box;
    font-size: 3.466666667vw;
}

.actions {
    margin-top: 10px;
    padding: 10px 20.266666667vw 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-top: 1px solid #e5e5e5;
}

.btn + .btn {
    margin-left: 4vw;
}

.btn-primary {
    background-color: #1aad19;
    color: white;
    border: solid 1px rgba(5, 5, 5, 0.08);
}

.btn-default {
    border: solid 2px #1aad19;
    color: #1aad19;
}
</style>



// WEBPACK FOOTER //
// src/components/trainer/TrainerApplyCell.vue